import { IAngularEvent, IController } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';

@injectable
export class ActionButtonController implements IController {
  public onClick: Function;
  handleClick(event: IAngularEvent) {
    event.stopPropagation();
    this.onClick();
  }
}
